/*eslint no-unreachable: "error"*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Arrow from '@/assets/images/icons/Arrow.vue';
import Building from '@/assets/images/icons/Building.vue';
import Calendar from '@/assets/images/icons/Calendar.vue';
import Checkmark from '@/assets/images/icons/Checkmark.vue';
import ChevronDown from '@/assets/images/icons/ChevronDown.vue';
import Pencil from '@/assets/images/icons/Pencil.vue';
import BankId from '@/assets/images/icons/BankId.vue';
import MapMarker from '@/assets/images/icons/MapMarker.vue';
import InfoCircle from '@/assets/images/icons/InfoCircle.vue';
import VTooltip from 'v-tooltip';
import VueGtag from 'vue-gtag';
import VueGtm from 'vue-gtm';
//import QRCode from 'qrcode-generator';

import axios from 'axios'
import VueAxios from 'vue-axios'
import Personnummer from 'personnummer'
Vue.directive('tooltip', VTooltip);
Vue.use(VueAxios, axios);
Vue.use(VTooltip);
//Vue.use(QRCode);
VTooltip.options.autoHide = false;
VTooltip.options.disposeTimeout = 10;


Vue.config.productionTip = false;
Vue.component('Arrow', Arrow);
Vue.component('Building', Building);
Vue.component('Calendar', Calendar);
Vue.component('Checkmark', Checkmark);
Vue.component('ChevronDown', ChevronDown);
Vue.component('Pencil', Pencil);
Vue.component('BankId', BankId);
Vue.component('MapMarker', MapMarker);
Vue.component('InfoCircle', InfoCircle);

var moment = require('moment');
var qrcode = require('qrcode-generator');
console.log(qrcode);
//var pNum = require('personnummer');

// TODO: Only show for production!

// Vue.use(VueGtag, {

//   config: { id: "UA-39398649-1" }
//   //config: { id: "UA-108262992-1" }   // dev
//   , params: {
//       send_page_view: false
//     }
// }, router);

Vue.use(VueGtm, {
	id: "GTM-KGG44JZL"
});


new Vue({
  router,
  render: h => h(App),
  data: {
    strings: {
        'fixed': 'Fast',
        'variable': 'Rörligt'
    },
    isProduction: process.env.VUE_APP_PRODUCTION === 'true',
    publicUrl: process.env.VUE_APP_public_url, //'https://www.boraselhandel.se/teckna-elavtal', // see vue.config publicPath
    type: 'apartment',
    flowString: '',
    heater_type: null,
    estimated: false,
    direct_watts: 2000,
    boras: true,
    area_possible: true,
    people: 2,
    surface: 100,
    hideMovablePriceDivs: false,
    hideFixedPriceDivs: true,
    price_type: '',
    commitment: 1,
    asap: false,
    possible_properties: [],
    possible_properties_index_choice: -1,
    start: null,
    customer: 'new',
    old_customer_type: null,
    choose_start_date_string: '',
    step_customer_ok: false,
    barncancerfonden: false,
	solvatten: false,
    miljoval: false,
	energysource: 'fossilfriel',
	/*
	vattenkraft: false,
	vindkraft: false,
	karnkraft: false,
	fossilfriel: true,
	*/
    prisbevakning: false,
    prisbevakning_option: 35,
    bonus_code: '',
    bonus_data: null,
    personnummer: null,
    pappersfaktura: true,
    name: null,
    surname: null,
    address: null,
    postal_code: null,
    location: null,
    phone: null,
    customerKey : null,
    email: null,
    emailAutoComplete:  {domains:[
        "gmail.com",
        "googlemail.com",
        "comcast.net",
        "yahoo.com",
        "hotmail.com",
        "hotmail.co.uk",
        "aol.com",
        "msn.com",
        "yahoo.co.uk",
        "live.com",
        "live.co.uk",
        "icloud.com"
      ], 
        defaultDomains:[
        "gmail.com",
        "googlemail.com",
        "comcast.net",
        "yahoo.com",
        "hotmail.com",
        "hotmail.co.uk",
        "aol.com",
        "msn.com",
        "yahoo.co.uk",
        "live.com",
        "live.co.uk",
        "icloud.com"
      ]},
    spotprice_lastmonth: null,
    additionalcosts_volumeCost: 0,
    email_confirm: null,
    another_address: false,
    invoice_address_same_as_property: true,
    invoice_address: null,
    invoice_postal_code: null,
    invoice_location: null,
    other_address: null,
    other_postal_code: null,
    other_location: null,
    providing_cunstruction_and_territory_id: true,
    not_providing_cunstruction_and_territory_id: false,
    construction_id: '735 999',
    territory_id: null,
    acknowledgement: null,
    terms: false,
    terms_text: 'Jag har läst och godkänner ovanstående villkor samt att Borås Elhandel vid avtalsbeställning genomför en kreditupplysning.',
    terms_regret: false,
    terms_regret_text: 'Jag är medveten om att mitt elavtal kommer att starta innan tidsfristen på ångerrätten har löpt ut.',
    terms_datechange: false,
    terms_newstartdate: false,
    terms_newstartdate_text: '',
    autogiro: false,
    old_contract_description: '',
    searchcontract_start: false,
    searchPostalCode: '',
    searchConsumption: '',
    searchMovingIn: false,
    searchStartDate: '',
    calculateNewContractDate_message: '',
    newStartDate_message: '',
    contract: {
        contracts: null, // All available contracts
        area: 3, // Depending on user postal, 3 by default
        date: moment().format("YYYY-M-D"), // Today
        months: 12, // 12, 24, 36, 48, 60
        type: 'fixed', // fixed, movable, vinter
        postal: null
    },
    sign: {
        transactionId: null,
        autoStartToken: null,
        qrCode: null,
        ssn: null,
        status: 'idle',
        step: 1,
        collect: 0,
        requestType: 'MobileBankID',
        message: ''
    },
    auth: {
        transactionId: null,
        autoStartToken: null,
        qrCode: null,
        ssn: null,
        step: 1,
        collect: 0,
        requestType: 'MobileBankID',
    },
    feedback: {
		bonus_code: false,
        ssn: false,
        prop: ''
    },
    loading: false,
    summary : {
        send_to: process.env.VUE_APP_summary_send_to
    },
    detailsShow: '',
    contractDetailsShow: '',
    noPostalCodeFound: false
  },
  created() {
      document.title = 'Borås Elhandel - Hållbara energilösningar för privatperson och företag';
      /*if(this.$root.getCookie('elavtal').length < 10)
          window.location.replace(this.$root.publicUrl + '/api/nonce.php');*/

  },
  mounted(){
    //console.log ("mounted!");
    //console.log(this.$route);
	//console.log (this.$route);
  },
  watch: {
     /*'$route' (to) {
      // react to route changes...
     alert ("route change to '" + to + "'");
    },*/
    /*type(n) {

      if(this.range_hover)
        return;

      let direct_watts = this.direct_watts;
      let people = this.people;
      let surface = this.surface;

      switch(n) {
        case 'apartment':
          direct_watts = 2000;
          people = 2;
          surface = 80;
        break;
        case 'house':
          direct_watts = 5000;
          people = 3;
          surface = 120;
        break;
        case 'big_house':
          direct_watts = 20000;
          people = 4;
          surface = 200;
        break;
      }
      
      //this.direct_watts = direct_watts;
      //this.people = people;
      //this.surface = surface;
    },*/
    customer(n) {
        switch (n) {
            case 'new':
                if(this.old_customer_type)
                    this.step_customer_ok = true;
                break;
            case 'old':
                this.step_customer_ok = true;
                break;
        }
    },
    old_customer_type() {
        this.step_customer_ok = true;
    },
    direct_watts (n) {
        if(n<5000)
            this.type = 'apartment';

        if(n>5000 && n<20000)
            this.type = 'house';

        if(n>20000)
            this.type = 'big_house';

        if(n>29900)
            console.log('MAX MAX');

        if(n<0)
            n = 0;

        this.direct_watts = n;
    },
	energysource (n) {
		if (n == 'bramiljoval')
			this.miljoval = true;
		else
			this.miljoval = false;
	}
  },
  computed: {
    watts() {
        return this.direct_watts;
      //return this.estimated ? this.people * this.surface * 10 : this.direct_watts;
    },
    fixed_price() {
      return this.getFixedPrice(this.watts);
    },
    variable_price() {
        return this.getVariablePrice(this.watts);
    },
    timspot_price() {
        return this.getSpotPrice(this.watts);
    },
    mix5050_price() {
        return this.getMix5050Price(this.watts);
    },
    moms() {
      return this.net_price * .25;
    },
    net_price() {
        if (this.price_type === 'mix5050') {
            return this.mix5050_price;
        } else if (this.price_type === 'spotavtal') {
            return this.timspot_price;
        }

      return this.price_type === 'fixed' ? this.fixed_price : this.variable_price;
    },
    price() {
        if (this.price_type === 'mix5050') {
            return this.mix5050_price;
        } else if (this.price_type === 'spotavtal') {
            return this.timspot_price;
        }

        return this.price_type === 'fixed' ? this.fixed_price : this.variable_price;
    },
    final_price() {
      let price = this.price;
      if (this.barncancerfonden) {
        price += 10 * 12;
      }
      if (this.miljoval) {
        price += 25 * 12;
      }
      if (this.prisbevakning) {
        price += 10 * 12; //parseInt(this.prisbevakning_option);
      }
      return Math.round(price);
    },
    step() {
      let step = 1;
      switch(this.$route.name) {
        case 'contractselection':
              step = 1;
              break;
        case 'customernew':
            step = 2;
            break;
        case 'ordersummary':
            step = 3;
            break;
      }
      return step;
    },
  },
  methods: {
    send() {
      alert('SENT!!');
    },
    generateQrCodeImgTag(txt) {
        
        let qr = qrcode(15, 'H');
        qr.addData(txt);
        qr.make();
        return qr.createImgTag(3);
    },
    tagInDisabledMode(tag) {
        return (this.$root.detailsShow != tag && this.$root.flowString.indexOf(tag) < 0);
    },
    tagInViewMode(tag, isRequired) {
        
        if (typeof(isRequired) == 'undefined')
            isRequired = true;

        if (!isRequired) {
            return (this.$root.detailsShow != tag);
        }

        return (this.$root.detailsShow != tag && this.$root.flowString.indexOf(tag) >= 0);
    },
    tagInEditMode(tag, isRequired) {

        if (typeof(isRequired) == 'undefined')
            isRequired = true;

        if (!isRequired) {
            return (this.$root.detailsShow===tag);
        }

        return (this.$root.detailsShow===tag|| this.$root.flowString.indexOf(tag) < 0);
    },
    tagHasBeenVisited (tag) {
        let r = (this.$root.flowString.indexOf(tag) >= 0);
        return r;
    },
    tagSetEditMode (tag) {
        return this.showDetails(tag);
    },
    is_any_contract_available() {
        if(!this.contract.contracts || this.contract.area < 1 || this.contract.area > 4)
            return false;

        return true;

    },
    is_fixed_contract_available(){
        if(!this.contract.contracts)
            return false;

        return true;
    },
    is_fixed3_contract_available(){
        if(!this.contract.contracts)
            return false;

        return true;
    },
    showDetails(tag) {
        if(this.$root.detailsShow == tag) {
            this.$root.detailsShow = '';
        }else{
            this.$root.detailsShow = tag;
        }
    },
    showContractsDetails(tag) {
        if(this.$root.contractDetailsShow == tag) {
            this.$root.contractDetailsShow = '';
        }else{
            this.$root.contractDetailsShow = tag;
        }
    },
    getSelectedEnergySourceTitle() {

        return this.getEnergySourceTitle(this.energysource);
    },
    getSelectedEnergySourceTitleObject() {

        return this.getEnergySourceTitleObject(this.energysource);

    },    
    getSelectedEnergySourcePriceText(includeVAT) {

        return this.getEnergySourcePriceText(this.energysource, includeVAT);

    },
    getSelectedEnergySourcePrice(includeVAT) {
        
        return this.getEnergySourcePrice(this.energysource, includeVAT);

    },
    getEnergySourceStandardTitle(sourceName) {
        switch (sourceName.toLowerCase()) {
            case "vattenkraft": return "Vattenkraft";
            case "vindkraft": return "Vindkraft";
            case "karnkraft": return "Kärnkraft";
            case "bramiljoval": return "Bra Miljöval";
            case "fossilfriel": return "100% fossilfri el";
            default: return "Okänt";
        }
    },
    getEnergySourceTitle(sourceName) {
        const standardTitle = this.getEnergySourceStandardTitle(sourceName);

        switch (sourceName.toLowerCase()) {
            case "bramiljoval": return `${standardTitle} (${this.timspot_contract().monthName})`;
            default: return standardTitle;
        }
    },
    getEnergySourceTitleObject(sourceName) {
        const standardTitle = this.getEnergySourceStandardTitle(sourceName);

        let extraTitle = '';

        switch (sourceName.toLowerCase()) {
            case "bramiljoval": 
                extraTitle = ' (' + this.timspot_contract().monthName + ')';
                break;
        }

        return {
            title: standardTitle,
            extra: extraTitle
        };
    },
    getEnergySourcePriceText(sourceName, includeVAT) {

        const priceInfo = this.getEnergySourcePrice(sourceName, includeVAT);

        if (priceInfo === null) {
            return 'Okänt';
        }

        console.log("priceInfo", priceInfo);

        let priceTexts = [];

        if (priceInfo.priceSEKPerMonth != null && priceInfo.priceSEKPerMonth != 0) {
            priceTexts.push(priceInfo.priceSEKPerMonth + ' kr/mån');
        } else if (priceInfo.priceCentPerKWh != null && priceInfo.priceCentPerKWh != 0) {
            priceTexts.push(priceInfo.priceCentPerKWh + ' öre/kWh');
        }

        console.log("priceTexts", priceTexts);

        let priceText = priceTexts.join(', ');

        return priceText;
    },
    getEnergySourcePrice(sourceName, includeVAT) {

        let priceSEKPerMonthExcludingVAT = null;
        let priceCentPerKWhExcludingVAT = null;

        switch (sourceName.toLowerCase()) {
            case 'fossilfriel': 
            case 'karnkraft':
                priceSEKPerMonthExcludingVAT = 0;
                break;

            case 'bramiljoval':
                priceCentPerKWhExcludingVAT = 2.04;
                break;
        }

        const factor = (includeVAT) ? 1.25 : 1.0;

        return {
            priceSEKPerMonth: (priceSEKPerMonthExcludingVAT != null) ? priceSEKPerMonthExcludingVAT * factor : 0,
            priceCentPerKWh: (priceCentPerKWhExcludingVAT != null) ? priceCentPerKWhExcludingVAT * factor : 0,
        };

    },
    showTermsRegret() {
        let now = new Date();
        let regretLimit = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 14);

        let contractDate = new Date(this.$root.contract.date);

        console.log ('contractDate = ' + contractDate);
        console.log ('regretLimit = ' + regretLimit);

        return (contractDate < regretLimit);
    },
    calculateNewContractDate() {

        let now = new Date();

        //this.$root.calculateNewContractDate_message = '';

        //if (this.$root.customer == 'old_with_new_property') {

        //}
        //else 
        if (this.customer == 'old') {

            let needToBeNextMonth = false;
            let needToBeNextMonthCause = '';

            if (this.old_contract_description.indexOf('tim') >= 0 && this.price_type != 'spotavtal') {

                needToBeNextMonth = true;
                needToBeNextMonthCause = 'from_timspot_to_any_other';
            } else if (this.price_type == 'mix5050' || this.price_type == 'fixed') {
                needToBeNextMonth = true;
                needToBeNextMonthCause = 'cant_start_middle_of_month';
            }

            console.log("needToBeNextMonth = " + needToBeNextMonth);
            console.log("needToBeNextMonthCause = " + needToBeNextMonthCause);

            if (needToBeNextMonth) {
                //const newMinDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);

                const contractDate = moment(this.contract.date, 'YYYY-MM-DD').toDate();

                if (contractDate.getDate() != 1) {

                    switch (needToBeNextMonthCause) {
                        case 'from_timspot_to_any_other':
                            this.calculateNewContractDate_message = 'Vid byte från timavtal så kan ditt nya elavtal starta den 1:e i nästkommande månad.';
                            break;

                        case 'cant_start_middle_of_month':
                            this.calculateNewContractDate_message = 'Vid byte på befintligt elavtal så kan ditt nya elavtal starta den 1:e i nästkommande månad.';
                            break;
                    }

                    console.log ("msg: " + this.calculateNewContractDate_message);
                    let newDate = getNextMonthDate(contractDate);

                    return moment(newDate).format("YYYY-MM-DD");
                }
            }

            return this.contract.date;
        }

        let daysAdd = 5;

        if (!this.searchMovingIn) {
            daysAdd = 21;
        }

        let newDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysAdd);

        return moment(newDate).format("YYYY-MM-DD");

    },
    fixed_contract(){
        if(!this.is_fixed_contract_available())
            return {price: 0, addon: 0, elCert: 0 };

        for(var i = 0; i<this.contract.contracts.length; i++){
            var contract = this.contract.contracts[i];
            if(contract.months === this.contract.months && contract.type === 'fixed'){
                return contract;
            }
        }

        return {price: 0, addon: 0, elCert: 0};
    },
    fixed_months_contract(months){
        if(!this.is_fixed_contract_available())
            return {price: 0, addon: 0, elCert: 0 };

        for(var i = 0; i<this.contract.contracts.length; i++){
            var contract = this.contract.contracts[i];
            if(contract.months === months && contract.type === 'fixed'){
                return contract;
            }
        }

        return {price: 0, addon: 0, elCert: 0};
    }, 
    change_fixed_months(months){
        this.contract.months = months;
    },   
    movable_contract(){
        if(!this.contract.contracts)
            return {
                price: 0,
                addon: 0,
                elCert: 0
            };
      
        let r = this.contract.contracts[0];
        r.monthName = '';

        if (r.minStartDate != null) {
            r.monthName = this.getMonthName(moment(r.minStartDate, "YYYY-MM-DD").toDate());
        } else if (r.timeUpdated != null) {
            r.monthName = this.getPreviousMonthName(moment(r.timeUpdated, "YYYY-MM-DD").toDate());
        }

        return r;
    },
    timspot_contract(){
        return {
            price: this.spotprice_lastmonth.priceAverage, //223.02,
            addon: this.movable_contract().addon,
            elCert: this.movable_contract().elCert,
            price_lowest: this.spotprice_lastmonth.priceLowest, // 0.05,
            price_highest: this.spotprice_lastmonth.priceHighest, //851.33,
            monthlyFee: this.movable_contract().monthlyFee,
            monthName: this.getPreviousMonthName(new Date()),
            purchaseCost: 4.22 // 2.69 //1.83
        };
    },
    round_value(num){
        return (Math.round((num + Number.EPSILON) * 100.0) / 100.0).toFixed(2);
    },
    getPreviousMonthName(dt) {
        return this.getMonthName(moment(dt).subtract(1, "month").toDate());
    },
    getMonthName(dt) {
        moment.locale('sv');
        return moment(dt).format("MMMM").toLowerCase();
    },
    changeContractTime() {
        this.contract.months = this.commitment * 12;
        //setPriceObject(this);
    },
    changeContractType(priceType, newCommitment) {
        if (typeof(priceType) == 'undefined') {
            priceType = '';
        }
        if (typeof(newCommitment) == 'undefined') {
            newCommitment = 0;
        }

        if (priceType == 'fixed') {
            this.commitment = newCommitment;
        }

      if(this.price_type === 'variable') {
        this.hideMovablePriceDivs = false;
        this.hideFixedPriceDivs = true;
      }else{
          this.hideMovablePriceDivs = true;
          this.hideFixedPriceDivs = false;
      } 

		fixDistanceOnPriceButtons();
	setTimeout(function () {
		fixDistanceOnPriceButtons();
	}, 10);
    },
    getPriceAreaForPostalCodeUsingApi(t, callback) {
        if (t >= '50100' && t <= '50670') {
            console.log("Pricearea installed: " + t + " == " + 3);
            callback(3);
            return 3;
        }

        let obj = {};
        obj.searchPostalCode = t;

        axios.post(this.publicUrl + "/api/getpriceareafrompostalcode.php", JSON.stringify(obj))
            .then(function (response) {
                console.log("response:");
                console.log(response);
                if(response != null && response.data != null && 
                    response.data.priceArea != null && response.data.priceArea != '') {
                    let priceAreaNo = response.data.priceArea.replace('SE', '');

                    console.log("Found pricearea: " + response.data.priceArea + " == " + priceAreaNo);
                    callback(priceAreaNo);
                } else {
                    alert ("Något fel inträffade!");
                    callback(0);
                }
            });
        
        return 0;
    },
    getPriceAreaForPostalCode(t) {
      var e = [];

      if(t == "82454" || t == "82478" || t == "82479" || t == "82400" || t == "82167" || t == "82460" || t == "82673") {
        return 2;
      }
      if(t == "79792" || t == "51491" || t == "40532" || t == "79290" || t == "79492" || t == "79392" || t == "79592" || t == "40545" || t == "74345") {
        return 3;
      }
      if(t == "51261" || t == "21111" || t == "57995" || t == "21131") {
        return 4;
      }
      e[0] = "91534-98499", e[1] = "79023-79699,80596-80598,81192-81195,81630-81631,81690-81695,81730-81730,81740-81740,81791-81794,82010-82011,82020-82029,82040-82043,82046-82046,82050-82051,82060-82065,82070-82078,82130-82136,82140-82143,82150-82151,82158-82158,82191-82195,82198-82198,82230-82231,82240-82240,82291-82292,82299-82299,82330-82330,82391-82393,82430-82434,82440-82443,82450-82452,82491-82494,82530-82532,82591-82596,82630-82640,82650-82650,82660-82662,82670-82670,82691-82695,82730-82740,82791-82795,82830-82891,82894-82894,82869-84079,84081-84084,84086-84093,84095-84298,84300-89693,90130-91532,91597-92275,92278-92399,93027-93592", e[2] = "11115-19793,33230-33236,41101-51260,51264-51463,51492-57063,57131-57197,57331-57495,57531-57895,58128-59091,59094-79022,79024-79069,79071-79089,79092-79497,80250-81629,81632-81695,81791-81791,81830-81834,81841-81843,81891-81892,81930-81966,82892-82892,82895-82895,84080-84080,84085-84085,84094-84094,84299-84299", e[3] = "20522-20522,21112-39591,57072-57091,56013-56013,56025-56025,56291-56291,56891-57012,57015-57016,57230-57296,57474-57492,57496-57498,57692-57692,57738-57738,57791-57791,57793-57793,57930-57993";
      for (var a = 0; a < e.length; a++) for (var n = e[a].split(","), r = 0; r < n.length; r++) {
          var i = n[r].split("-"), l = i[0], o = i[1];
         
          if (l <= t && t <= o) {
            return a + 1;
          }   
      }
      return 0
    },
    loadContracts(callback){

        let loadContractsUrl = 'https://api.energiinfo.se/SubmitContract/2.6/api/v1/contracttypes/active';

        console.log("this.isProduction = " + this.isProduction);
        console.log(!this.isProduction);
        console.log(this.isProduction == false);
        console.log(this.isProduction === false);
        console.log(this.isProduction === 'false');

        // if (!this.isProduction) {
        //     console.log('func?');
        //     loadContractsUrl = 'https://api.energiinfo.se/SubmitContract/dev/api/v1/contracttypes/active';
        // }

        console.log("loadContractsUrl");
        console.log(loadContractsUrl);

        fetch(loadContractsUrl).then(r => r.json()).then(r => {
            console.log(r);
            this.contract.contracts = r;
            loadPricesForAreaDate(this, this.contract.area, this.contract.date, callback);
        });
    },
    getVariablePrice(watts){
        if(!this.contract.contracts)
            return '...';

        var contract = this.movable_contract();
        var price_inc_tax = (contract.price + contract.addon + contract.elCert) * 1.25;
        var year_price = watts * price_inc_tax / 100;
        var month_price = year_price/12;
        if(!month_price)
          return '...';

        return Math.round(year_price + (contract.monthlyFee * 12));
    },
    getSpotPrice(watts){
        if(!this.contract.contracts)
            return '...';

        var contract = this.timspot_contract();
        var price_inc_tax = (contract.price + contract.addon + contract.elCert) * 1.25;
        var year_price = watts * price_inc_tax / 100;
        var month_price = year_price/12;
        if(!month_price)
          return '...';

        return Math.round(year_price + (contract.monthlyFee * 12));
    },
    getFixedPrice(watts){
        var contract = this.fixed_contract();
        var price_inc_tax = contract.price * 1.25;
        var year_price = watts * price_inc_tax / 100;
        var month_price = year_price / 12;

        if(!month_price)
            return '...';

        return Math.round(year_price + (contract.monthlyFee * 12));
    },
    getMix5050Price(watts){
        if(!this.movable_contract().price)
            return '...';
        var movablePrice = (this.movable_contract().elCert + this.movable_contract().addon + this.movable_contract().price) * 1.25;
        var movableCost = (watts * movablePrice)/200;
        var fixedPrice = this.fixed_months_contract(12).price * 1.25;
        var fixedCost = (watts * fixedPrice)/200;

        var yearFee = this.movable_contract().monthlyFee * 12;

        var totalCost = fixedCost + movableCost + yearFee;
        return Math.round(totalCost);
    },
    getTotalFixedPriceUsingMonths(months, watts, skipMonthlyFee){

        if (typeof(skipMonthlyFee) == 'undefined' || !skipMonthlyFee)
            skipMonthlyFee = false;

        if(!this.movable_contract().price)
            return '...';

        const energySourcePrice = this.getSelectedEnergySourcePrice(true);

        var price = this.fixed_months_contract(months).price*1.25 + energySourcePrice.priceCentPerKWh;
        var year = (!skipMonthlyFee) ? ((this.fixed_months_contract(months).monthlyFee + energySourcePrice.priceSEKPerMonth) * 12) : 0;
        var cost = (watts * price)/100;
        cost = (cost + year)/watts*100;
        return this.round_value(cost);
    },
    getTotalFixedPrice(watts, skipMonthlyFee){

        if (typeof(skipMonthlyFee) == 'undefined' || !skipMonthlyFee)
            skipMonthlyFee = false;

        if(!this.movable_contract().price)
            return '...';
        var price = this.fixed_contract().price*1.25;
        var year = (!skipMonthlyFee) ? (this.fixed_contract().monthlyFee * 12) : 0;
        var cost = (watts * price)/100;
        cost = (cost + year)/watts*100;
        return this.round_value(cost);
    },
    getTotalVariablePrice(watts, skipMonthlyFee){
        
        if (typeof(skipMonthlyFee) == 'undefined' || !skipMonthlyFee)
            skipMonthlyFee = false;

        if(!this.movable_contract().price)
            return '...';

        const energySourcePrice = this.getSelectedEnergySourcePrice(true);

        var price = (this.movable_contract().elCert + this.movable_contract().addon + this.movable_contract().price) * 1.25 + energySourcePrice.priceCentPerKWh;
        var year = (!skipMonthlyFee) ? ((this.movable_contract().monthlyFee + energySourcePrice.priceSEKPerMonth) * 12) : 0;
        var cost = (watts * price)/100;
        cost = (cost + year)/watts*100;
        return this.round_value(cost);
    },
    getTotalSpotPrice(watts, skipMonthlyFee){

        if (typeof(skipMonthlyFee) == 'undefined' || !skipMonthlyFee)
            skipMonthlyFee = false;

        if(!this.timspot_contract().price)
            return '...';

        const energySourcePrice = this.getSelectedEnergySourcePrice(true);

        var price = (this.timspot_contract().purchaseCost + this.timspot_contract().elCert + this.timspot_contract().addon + this.timspot_contract().price);
        price += energySourcePrice.priceCentPerKWh
        var year = (!skipMonthlyFee) ? ((this.timspot_contract().monthlyFee + energySourcePrice.priceSEKPerMonth) * 12) : 0;
        var cost = (watts * price)/100;
        cost = (cost + year)/watts*100;
        return this.round_value(cost*1.25);
    },
    getTotalMix5050Price(watts, skipMonthlyFee){

        if (typeof(skipMonthlyFee) == 'undefined' || !skipMonthlyFee)
            skipMonthlyFee = false;

        if(!this.movable_contract().price)
            return '...';

        const energySourcePrice = this.getSelectedEnergySourcePrice(true);
        
        var movablePrice = (this.movable_contract().elCert + this.movable_contract().addon + this.movable_contract().price) * 1.25 + energySourcePrice.priceCentPerKWh;
        var movableCost = (watts * movablePrice)/200;
        var fixedPrice = this.fixed_months_contract(12).price * 1.25;
        var fixedCost = (watts * fixedPrice)/200;

        var yearFee = (!skipMonthlyFee) ? ((this.movable_contract().monthlyFee + energySourcePrice.priceSEKPerMonth) * 12) : 0;

        var totalCost = fixedCost + movableCost + yearFee;
        var totalCostPerWatt = (100.0 * totalCost / watts);
        return this.round_value(totalCostPerWatt);
    },
    getVATMix5050(){
        if(!this.movable_contract().price)
            return '...';
        var movablePrice = this.movable_contract().elCert + this.movable_contract().addon + this.movable_contract().price;            
        var fixedPrice = this.fixed_months_contract(12).price;
        var vat = (movablePrice + fixedPrice) * 0.5 * 0.25;
        return this.round_value(vat);
    },
    publishCommitment() {
        if (this.commitment == 0.41) {
            return "5 mån";
        }

        return this.commitment + ' år';
    }, 
    /*getWithoutMonthlyCostMix5050Price(){
        let priceFixed = this.getWithoutMonthlyCostFixedPrice();
        let priceVariable = this.getWithoutMonthlyCostVariablePrice();

        return this.round_value(priceFixed * 0.5 + priceVariable * 0.5)
    },
    getWithoutMonthlyCostFixedPrice(){
        if(!this.movable_contract().price)
            return '...';
        var price = this.fixed_contract().price*1.25;
        return this.round_value(price);
    },
    getWithoutMonthlyCostVariablePrice(){
        if(!this.movable_contract().price)
            return '...';
        var price = (this.movable_contract().elCert + this.movable_contract().addon + this.movable_contract().price) * 1.25;
        return this.round_value(price);
    },
    getWithoutMonthlyCostSpotPrice(){
        if(!this.movable_contract().price)
            return '...';
        var price = (this.timspot_contract().purchaseCost + this.timspot_contract().elCert + this.timspot_contract().addon + this.timspot_contract().price) * 1.25;
        return this.round_value(price);
    },*/
    validatePersonnummer(num){
        //const Personnummer = require('personnummer');

        var valid = Personnummer.valid(num);
        if(valid) {
            var ssn = Personnummer.parse(num);
            return ssn.format(true);
        }else{
            this.feedback.ssn = true;
            return false;
        }
    },
    prettyT (num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    getCustomerTypeInfo () {
        var txt = '';
        
        if (this.customer == 'old') {
        txt = 'Befintlig kund';
        } else if (this.customer == 'new') {
        txt = 'Ny kund';
            /*if (this.old_customer_type == 'moving') {
                txt = 'Ny kund - Inflyttning';
            } else if (this.old_customer_type == 'changing') {
                txt = 'Ny kund - Byte';
            }*/
        } else if (this.customer == 'old_with_new_property') {
        txt = 'Befintlig kund med ny anläggning';
        }
        
        return txt;
    },
    getParameterValueFromStr(name, str) {
        if (str.substr(0, 1) == '#') {
            str = str.substr(1);
        }
        name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
        let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        let results = regex.exec("?" + str);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));	
    },
    getParameterValue(name) {
        let res = this.getParameterValueFromStr (name, location.hash);
    
        if (!res || res == null || res == '')
        {
            res = this.getParameterValueFromStr (name, location.search);
        }
    
        return res;
    },
    //trackClickEvent(eventName, eventValue) {
    trackClickEvent() {
     
        // if(eventValue) {
        //     this.$gtag.event(eventName, {
        //         'event_label': eventValue
        //       })
        // }else {
        //     this.$gtag.event(eventName)
        // }
    }
  }
}).$mount("#app");

// Preloads all prices för one area and date
function loadPricesForAreaDate(app, area, dateString, callback) {
    console.log('Loading price for area:', area, 'and start date', dateString);
    for(var i = 0; i<app.contract.contracts.length; i++){
        const contract = app.contract.contracts[i];
        const isFixed = contract.type == 'fixed' || contract.type == 'mix5050';

        if (isFixed) {
            dateString = convertDateToDateString(getFixedPriceDate(convertDateStringToDate(dateString)));
        }

        var url = contract.fetchPricesFromUrlDirect;
        url = url.replace("[[AREA]]", area);
        url = url.replace("[[DATE]]", dateString);

        fetch(url).then(r => r.json()).then(r => {
            for(var ii = 0; ii<r.length; ii++){
                var price = r[ii];
                console.log (price);
                for(var iii = 0; iii<app.contract.contracts.length; iii++){
                    if(price.defId === app.contract.contracts[iii].elPrices_DefId && price.partId === app.contract.contracts[iii].elPrices_PartId) {
                        app.contract.contracts[iii]['price'] = price.price;
                        app.contract.contracts[iii]['timeUpdated'] = price.timeUpdated;
                        app.contract.contracts[iii]['minStartDate'] = price.minStartDate;
                        app.direct_watts++;
                        app.direct_watts--;
						fixDistanceOnPriceButtons();
                    }
                }
            }
			fixDistanceOnPriceButtons();
            if (typeof(callback) != 'undefined' && callback != null) {
                callback(contract.type);
            }
        });
    }
}

/*function calculateAge(lcSSN)
{
    var dateparts = lcSSN.match(/(\d{4})(\d{2})(\d{2})/);
    if (dateparts != null) {
        var birthDate = new Date(dateparts[1], dateparts[2]-1, dateparts[3]); // months 0-based!
        var today = new Date();
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    } else {
        return null;
    }
}*/

function fixDistanceOnPriceButtons() {

        return;
        /*
      var diff = document.getElementsByClassName('elpris__commitment price__type')[0].offsetWidth-document.getElementsByClassName('elpris__commitment-title')[0].offsetWidth;

		var textSize = 30;
		
      if (diff > 100) {
			var sizePerButton = diff / 5;
			
			var sizeLeftPerButton = sizePerButton - textSize;
			
			var paddingLeft = sizeLeftPerButton / 4;
			
			sizeLeftPerButton = sizeLeftPerButton - paddingLeft;
			
			var w = sizeLeftPerButton / 2.0;
			
            var h = w / 2;

            var arr = document.getElementsByClassName('elpris__commitment-label');

            for (var i = 0; i < arr.length; i++) {
				document.getElementsByClassName('elpris__commitment-wrapper')[i].style.paddingLeft = paddingLeft + 'px';
                arr[i].style.padding = h + "px " + w + "px";
            }
      }

      var totWidth = [];
      totWidth[0] = document.getElementsByClassName('elpris__summary-title')[0].offsetWidth;
      totWidth[1] = document.getElementsByClassName('elpris__summary-title')[1].offsetWidth;
      
      var selIndex = 0;
      
      if (totWidth[1] > 0)
          selIndex = 1;
      
      //console.log ("selIndex = " + selIndex);
      var subTitleWidth = document.getElementsByClassName('elpris__summary-subtitle')[selIndex].offsetWidth;
      //console.log ("subTitleWidth = " + subTitleWidth);
      var detailsTextWidth = document.getElementsByClassName('elpris__summary-details-title')[selIndex].offsetWidth;
      //console.log ("detailsTextWidth = " + detailsTextWidth);
      var marginRight = (totWidth[selIndex] - subTitleWidth - detailsTextWidth) / 2.0;
      //console.log ("marginRight = " + marginRight);
      document.getElementsByClassName('elpris__summary-details-title')[selIndex].style.marginRight = marginRight + 'px';
      */
	}
    function convertDateStringToDate(dateString) {
        const dt = moment(dateString, 'YYYY-MM-DD').toDate();
        return dt;
    }

    function convertDateToDateString(dt) {
        return moment(dt).format("YYYY-MM-DD");
    
    }

    function getFixedPriceDate(dt) {

        if (dt.getDate() == 1) {
            return dt;
        }

        const newFirstInMonth = new Date(dt.getFullYear(), dt.getMonth() + 1, 1);

        return newFirstInMonth;
    }

    function getNextMonthDate(dt) {

        const newFirstInMonth = new Date(dt.getFullYear(), dt.getMonth() + 1, 1);

        return newFirstInMonth;
    }

    

